export default __webpack_public_path__ + "static/33-6a47b0800c8678989f34176c405a93c5.png";